import PropTypes from 'prop-types';
import React from 'react';

import AdminBrowseHomePage from 'app/components/admin/browse/home/AdminBrowseHomePage';

export function AdminBrowseHomePageRoute({ basePageRoute }) {
  return <AdminBrowseHomePage basePageRoute={basePageRoute} />;
}

AdminBrowseHomePageRoute.propTypes = {
  basePageRoute: PropTypes.string.isRequired
};

export default AdminBrowseHomePageRoute;
